module.exports = __webpack_public_path__ + "static/media/icon-gh-lblue.cfab2240.svg";